import type { priceChangeFavoriteCaseNotification_fragment$key } from '__generated__/priceChangeFavoriteCaseNotification_fragment.graphql.ts';
import classNames from 'classnames';
import Icon from 'components/atoms/icon/icon.tsx';
import Typography from 'components/atoms/typography/typography.tsx';
import { FormattedMessage } from 'react-intl';
import { graphql, useFragment } from 'react-relay';
import { Link } from 'react-router-dom';
import { formatDate } from '../../../../tools/string-formatters.ts';

const fragment = graphql`
    fragment priceChangeFavoriteCaseNotification_fragment on PriceChangeOnFavoriteCaseNotification {
        id
        read
        createdDate
        case {
            address
            relationType {
                relationId
            }
        }
    }
`;

type Props = {
  notification: priceChangeFavoriteCaseNotification_fragment$key;
};

export const PriceChangeFavoriteCaseNotification = (props: Props) => {
  const data = useFragment(fragment, props.notification);
  return (
    <Link
      className={classNames('notifications__link', { unread: !data.read })}
      to={`/favorite/${data.case?.relationType?.relationId}`}
    >
      <Icon name="Bell" />
      <div className="notifications__item-text">
        <Typography>
          <FormattedMessage
            defaultMessage="The price have changed on one of your favorite cases:"
            id="Notifications.PriceChangedOnFavoriteCase"
          />
          &nbsp;
          <b>{data.case?.address}</b>
        </Typography>
        <Typography className="notifications__time" tagStyle="bodyXSmall">
          {formatDate(data.createdDate)}
        </Typography>
      </div>
    </Link>
  );
};
